import React from 'react';

import { DutyHourTypeDynFlag } from 'generated';
import { useTranslation } from 'react-i18next';

import { ControlledFlagCheckbox } from 'components/shared/ControlledFields/ControlledFlagCheckbox';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

export const DecentralizedDutyCodesSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <MultiStepForm.Section
      title={t('dutyHourTypes.section.decentralizedDutyCodes')}
    >
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        name="flags"
        flag="AVAILABLE_DECENTRALIZED"
        label={t(
          'dutyHourTypes.fieldName.availableForCreatingDecentralizedDutyCodes'
        )}
      />
    </MultiStepForm.Section>
  );
};
